import { gql } from '@apollo/client'

export default gql`
  mutation ClaimDailyCheckInBonus($input: ClaimDailyCheckInBonusInput) {
    claimDailyCheckInBonus(input: $input) {
      campaignID
      cycle
      day
      bonusHash
      isClaimedSuccess
    }
  }
`
